import { ViewModelResultadoEnvio } from '../shared/models/viewModelResultadoEnvio';
import { BaixaCobrancaService } from '../shared/services/baixaCobranca.service';
import { RegistroCobrancaService } from '../shared/services/registroCobranca.service';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material';
import { ViewModelEnviaCobranca } from '../shared/models/enviaCobranca.model';
import { WebCliente } from "../shared/models/webCliente.model";
import { WebClienteService } from '../shared/services/webCliente.service';
import { GerenciadorEmailService } from '../shared/services/gerenciadorEmail.service';
import { ViewModelEnviaCobrancaNovo } from '../shared/models/enviaCobrancaNovo.model';

@Component({
    selector: 'app-mensageriaintegracaobancaria',
    templateUrl: './mensageria-integracaobancaria.component.html',
    styleUrls: ['./mensageria-integracaobancaria.component.scss']
})

export default class MensageriaIntegracaoBancariaComponent implements OnInit {
    

    dataFormatada: string;
    
    dataNovo: Date;

    dataVencimento: Date;
    viewModelEnviaCobrancaNovo: ViewModelEnviaCobrancaNovo = new ViewModelEnviaCobrancaNovo();
    viewModelResultadoEnvio: ViewModelResultadoEnvio = new ViewModelResultadoEnvio();
    webCliente: WebCliente = new WebCliente();
    loading = false;
    today: Date = new Date();
    currentYear: number = this.today.getFullYear();
    currentMonth: number = this.today.getMonth();
    currentDay: number = this.today.getDate();
    minDate: Object = new Date(
        this.currentYear,
        this.currentMonth,
        this.currentDay
    );
    resultado: boolean = false;
    GerenciadorEmailService: GerenciadorEmailService;

    constructor(
        
        private readonly router: Router,
        private _snackBar: MatSnackBar,
        private readonly gerenciadorEmailService: GerenciadorEmailService,
        private readonly baixaCobrancaService: BaixaCobrancaService,
        private webClienteService: WebClienteService
    ) {

       // this.formataDataAtual();

    }

    ngOnInit() {
        this.webClienteService.getById(1).subscribe(cliente => { this.webCliente = cliente; });
        console.log(this.webCliente);
    }

    
    
    enviaCobrancaNovo() {
        this.loading = true;
        
        this.viewModelEnviaCobrancaNovo.dataNovo = this.formataDataAtual(this.dataNovo);;

        if (this.viewModelEnviaCobrancaNovo.dataNovo === undefined) {
            this.loading = false;
            this._snackBar.open('Preencha uma data de vencimento. ', 'X', {
                duration: 6000,
                panelClass: ['green-snackbar']

            });
        } else {
            
            this.gerenciadorEmailService.getEnvioMensagemLote(this.dataFormatada).subscribe(retorno => {
                this.loading = false;
                this.resultadoCobranca();
                this._snackBar.open('A solicitação foi realizada com sucesso. ', 'X', {
                    duration: 6000,
                    panelClass: ['green-snackbar']

                })


            }, error => {
                this.loading = false;
                this._snackBar.open(error.error, 'X', {
                    duration: 8000,
                    panelClass: ['red-snackbar']
                })
            });

        }
    }

    resultadoCobranca() {
        //this.formataDataAtual();
        this.gerenciadorEmailService.getResultadoEnvio(this.dataFormatada).subscribe(retorno => {
            if (retorno) {
                this.viewModelResultadoEnvio = retorno['data']; 
                this.resultado = true;
            }
        }, error => {
            this.loading = false;
            this._snackBar.open('Error ao trazer os Dados dos boletos', 'X', {
                duration: 8000,
                panelClass: ['red-snackbar']
            })
        });

    }

    baixaCobranca() {
        this.loading = true;
        this.gerenciadorEmailService.getEnvioMensagemLote('').subscribe(retorno => {
            this.loading = false;
            this._snackBar.open('A solicitação foi realizada com sucesso.', 'X', {
                duration: 6000,
                panelClass: ['green-snackbar']

            })


        }, error => {
            this.loading = false;
            this._snackBar.open('Erro ao realizar a solicitação.', 'X', {
                duration: 8000,
                panelClass: ['red-snackbar']
            })
        });
    }

    formataDataAtual(dataEntrada: Date) {
        var dia = dataEntrada.getDate();
        var mes = dataEntrada.getMonth() + 1;
        var ano = dataEntrada.getFullYear();
       return this.dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);

    }

    
    

}